// ESM shim for prop-types CJS module.
// Vite's SSR module runner can't handle named imports from CJS modules.
// PropTypes validators are no-ops in production anyway.

function shim() {}
shim.isRequired = shim

function getShim() {
	return shim
}

export const any = shim
export const array = shim
export const arrayOf = getShim
export const bigint = shim
export const bool = shim
export const checkPropTypes = shim
export const element = shim
export const elementType = shim
export const exact = getShim
export const func = shim
export const instanceOf = getShim
export const node = shim
export const number = shim
export const object = shim
export const objectOf = getShim
export const oneOf = getShim
export const oneOfType = getShim
export const shape = getShim
export const string = shim
export const symbol = shim
export const resetWarningCache = shim

const PropTypes = {
	any: shim,
	array: shim,
	arrayOf: getShim,
	bigint: shim,
	bool: shim,
	checkPropTypes: shim,
	element: shim,
	elementType: shim,
	exact: getShim,
	func: shim,
	instanceOf: getShim,
	node: shim,
	number: shim,
	object: shim,
	objectOf: getShim,
	oneOf: getShim,
	oneOfType: getShim,
	shape: getShim,
	string: shim,
	symbol: shim,
	resetWarningCache: shim,
}

PropTypes.PropTypes = PropTypes

export default PropTypes
